import { FC } from 'react';

interface TrophyIconProps {
  className?: string;
  fill?: string;
  size?: number;
  title?: string;
}

export const TrophyIcon: FC<TrophyIconProps> = ({
  className = '',
  fill = 'currentColor',
  size = 24,
  title,
}) => {
  return (
    <svg
      className={className}
      fill={fill}
      height={size}
      viewBox="0 0 1664 2048"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <path d="M458,1011c-49.333-108-74-231.667-74-371H128v96c0,52,31.5,106,94.5,162S364,991.667,458,1011z M1536,736v-96h-256  c0,139.333-24.667,263-74,371c94-19.333,172.5-57,235.5-113S1536,788,1536,736z M1664,608v128c0,47.333-13.833,95-41.5,143  s-65,91.333-112,130c-47,38.667-104.667,71.167-173,97.5s-140.167,41.167-215.5,44.5c-28,36-59.667,67.667-95,95  c-25.333,22.667-42.833,46.833-52.5,72.5S960,1374,960,1408c0,36,10.167,66.333,30.5,91s52.833,37,97.5,37  c50,0,94.5,15.167,133.5,45.5S1280,1650,1280,1696v64c0,9.333-3,17-9,23s-13.667,9-23,9H416c-9.333,0-17-3-23-9s-9-13.667-9-23v-64  c0-46,19.5-84.167,58.5-114.5S526,1536,576,1536c44.667,0,77.167-12.333,97.5-37s30.5-55,30.5-91c0-34-4.833-63.833-14.5-89.5  s-27.167-49.833-52.5-72.5c-35.333-27.333-67-59-95-95c-75.333-3.333-147.167-18.167-215.5-44.5s-126-58.833-173-97.5  c-47-38.667-84.333-82-112-130S0,783.333,0,736V608c0-26.667,9.333-49.333,28-68s41.333-28,68-28h288v-96c0-44,15.667-81.667,47-113  s69-47,113-47h576c44,0,81.667,15.667,113,47s47,69,47,113v96h288c26.667,0,49.333,9.333,68,28S1664,581.333,1664,608z" />
    </svg>
  );
};
